import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
type ScarcityBarProps = {
  spotsLeft?: number;
  totalSpots?: number;
};
export function ScarcityBar({
  spotsLeft = 9,
  totalSpots = 100
}: ScarcityBarProps) {
  const taken = totalSpots - spotsLeft;
  const percentage = Math.round(taken / totalSpots * 100);
  return <div className="w-full rounded-2xl border border-gold-500/40 bg-navy-900 p-4 sm:p-5" data-id="element-61" data-mp="2q2pvai4grd47">
      <div className="flex items-start gap-2" data-id="element-62" data-mp="2b5p0u6uw1421">
        <AlertTriangleIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold-500" aria-hidden="true" data-id="element-63" data-mp="2b933zhbdlhaj" />
        <p className="font-display text-[17px] font-bold uppercase leading-tight tracking-wide text-white sm:text-xl" data-id="element-64" data-mp="226lij53josol">
          Only {spotsLeft} promotional spots available
        </p>
      </div>

      <div className="mt-4" data-id="element-65" data-mp="e5p2erq8ufs">
        <div className="h-4 w-full overflow-hidden rounded-full bg-navy-950 ring-1 ring-white/10" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={percentage} aria-label={`${percentage}% of promotional spots already claimed`} data-id="element-66" data-mp="g0b5weqislg">
          <div className="h-full rounded-full bg-red-500" style={{
          width: `${percentage}%`
        }} data-id="element-67" data-mp="2zl1aknrimtbd" />
        </div>
        <div className="mt-2 flex flex-wrap items-center justify-between gap-x-3 gap-y-1 text-[11px] font-semibold uppercase tracking-wide sm:text-xs" data-id="element-68" data-mp="38dv6lwv6m7bx">
          <span className="text-red-400" data-id="element-69" data-mp="2koak53ztkrxw">{percentage}% already claimed</span>
          <span className="text-gold-400" data-id="element-70" data-mp="2gngt41r2yx0s">
            {spotsLeft} spots left at $27
          </span>
        </div>
      </div>

      <p className="mt-3 text-[12px] leading-relaxed text-white/70 sm:text-sm" data-id="element-71" data-mp="2unhxhr6k0ml0">
        Once the promotional spots are gone, the price returns to its regular
        value.
      </p>
    </div>;
}